import { regex } from './rules';

// `rules.js` owns the canonical regexes - re-exported here so join validation
// and the rest of the app share a single source of truth.
export { regex };

const validFormat = (regexp, key) => ({
    validate: (input) => new RegExp(regexp).test(input),
    getErrorKeys: () => ({ errorMessageKey: key })
});

export const notEmpty = (key) => ({
    validate: (input) => !!input,
    getErrorKeys: () => ({ errorMessageKey: key })
});

export const lengthAtLeast = (length, key) => ({
    validate: (input) => input.length >= length,
    getErrorKeys: () => ({ errorMessageKey: key })
});

export const lengthAtMost = (length, key) => ({
    validate: (input) => input.length <= length,
    getErrorKeys: () => ({ errorMessageKey: key })
});

export const numberAtLeast = (minNum, key) => ({
    validate: (input) => input >= minNum,
    getErrorKeys: () => ({ errorMessageKey: key })
});

export const numberAtMost = (maxNum, key) => ({
    validate: (input) => input <= maxNum,
    getErrorKeys: () => ({ errorMessageKey: key })
});

export const isWholeNumber = (key) => validFormat(regex.numeric, key);

export const isValidPropertyName = validFormat(regex.latinPropertyNameRegex, 'propertyName.regexError');
export const isValidUnicodePropertyName = validFormat(regex.unicodeCharacterRegex, 'propertyName.regexError');

export default {
    notEmpty,
    lengthAtLeast,
    lengthAtMost,
    numberAtLeast,
    numberAtMost,
    isWholeNumber,
    isValidPropertyName,
    isValidUnicodePropertyName,
    regex
};
